import {clampPivot} from "../customHooks/useZoomControls.jsx";

export const startPanning = (event, view, cameraContainer, zoom) => {
    if(event.ctrlKey) {
        event.preventDefault()
        view.style.cursor = "grab";
    }
    if (zoom > 1 && event.ctrlKey) {
        const rect = view.getBoundingClientRect();
        return {
            isPanning: true,
            startX: event.clientX - rect.left,
            startY: event.clientY - rect.top,
        };
    }
    return { isPanning: false };
};

export const movePanning = (event, state, view, cameraContainer, pixiCanvas) => {
    if (!state.isPanning) return state;
    if(event.ctrlKey) {
        event.preventDefault()
        view.style.cursor = "grab";
    }
    const rect = view.getBoundingClientRect();
    const currentX = event.clientX - rect.left;
    const currentY = event.clientY - rect.top;
    const dx = currentX - state.startX;
    const dy = currentY - state.startY;

    // Adjust pivot based on movement (divide by scale so it works correctly when zoomed)
    cameraContainer.pivot.x -= dx / cameraContainer.scale.x;
    cameraContainer.pivot.y -= dy / cameraContainer.scale.y;

    const { width: screenWidth, height: screenHeight } = pixiCanvas.screen;
    clampPivot(cameraContainer, screenWidth, screenHeight);

    return {
        isPanning: true,
        startX: currentX,
        startY: currentY,
    };
};

export const stopPanning = (state, view) => {
    if (state.isPanning) {
        view.style.cursor = "default";
    }
    return { isPanning: false };
};
